import Vue from "vue";
import Vuex from "vuex";
import * as auth from '@/store/modules/auth.js'
import * as superadmin from '@/store/modules/superadmin.js'
import * as globaladmin from '@/store/modules/globaladmin.js'
import * as marketAdmin from '@/store/modules/marketAdmin.js'
import * as entityadmin from '@/store/modules/entityadmin.js'
import * as entity from '@/store/modules/entity.js'
import * as entityResetPassword from './modules/entityResetPassword.js'
import * as adminResetPassword from './modules/adminResetPassword.js'
import * as mandate from './modules/mandate.js'
import * as entityManageToken from './modules/EntityTokenManagement'
import * as allAdmins from './modules/allAdmins'
import * as manageEntities from './modules/manageEntities'
import * as debate from './modules/debate'
import * as challenge from './modules/challenge.js'
import * as article from './modules/articles'
import * as callManagement from './modules/callManagement'
import * as marketplace from './modules/marketplace'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    superadmin,
    globaladmin,
    marketAdmin,
    entityadmin,
    entity,
    entityResetPassword,
    adminResetPassword,
    mandate,
    entityManageToken,
    allAdmins,
    manageEntities,
    debate,
    challenge,
    article,
    callManagement,
    marketplace
  }
});
